import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  bankAccount: new analytics.Event({
    name: 'Bank Account Details Submitted',
    description: 'Merchant submits bank account details',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['countryCurrencyPairs'],
  }),
  defaultBankAccount: new analytics.Event({
    name: 'Default Bank Account For Unspecified Currencies Selected',
    description: 'Merchant selected a default bank account for unspecified currencies',
    action: analytics.EVENT_ACTION.SELECT_OPTION,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
};
